import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { GlobeIcon } from '@yonderland/andes-icons';
import { Box, LinkButton, Popover, Icon, useIsClient } from '@yonderland/andes-react';
import { useState } from 'react';
import NewLanguagePopover from '../language-popover/NewLanguagePopover';
export const LanguageMenuItem = props => {
    const { currentLang, defaultLanguages } = props;
    const { alternateUrl } = useAemConfig();
    const [buttonRef, setButtonRef] = useState(null);
    const isClient = useIsClient();
    if (!defaultLanguages || defaultLanguages.length < 2) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Box, { display: "flex", children: _jsxs(LinkButton, { testId: "language_switch", theme: "neutral", variant: "tertiary", size: "sm", innerRef: setButtonRef, children: [_jsx(Icon, { source: GlobeIcon, size: "xs" }), currentLang.toUpperCase()] }) }), isClient && (_jsx(Popover, { targetElement: buttonRef, slim: true, customWidth: "280px", placement: "bottom-start", testId: "language_switcher_popup", children: _jsx(Popover.Body, { children: _jsx(NewLanguagePopover, { currentLang: currentLang, alternateUrl: alternateUrl }) }) }))] }));
};
